import {
  BooleanCons,
  NumberCons,
  RoutesCons,
  StringConst,
} from '../../constants/const';
import { BaseResponseHttp } from '../http/commons.model';

export class MenuAccordion {
  accordionGenerate: boolean;
  accordionGenerateExpanded: boolean;
  accordionMyProducts: boolean;
  accordionMyProfile: boolean;
  accordionMyOrders: boolean;
  accordionMyOrdersExpanded: boolean;
  accordionDoctorList: boolean;
  accordionCatalog: boolean;
  accordionCatalogExpanded: boolean;
  accordionInvoice: boolean;
  accordionUtilities: boolean;
  accordionUtilitiesExpanded: boolean;
  accordionSales: boolean;
  accordionSalesExpanded: boolean;
  accordionMissingProducts: boolean;
  accordionSapReports: boolean;
  accordionSapReportsExpandex: boolean;
  accountState: boolean;
  promotions: boolean;
  codePromo: boolean;
  accordionCodePromoExpandex: boolean;
  constructor() {
    this.accordionGenerate = BooleanCons.false;
    this.accordionGenerateExpanded = BooleanCons.false;
    this.accordionMyProducts = BooleanCons.false;
    this.accordionMyProfile = BooleanCons.false;
    this.accordionMyOrders = BooleanCons.false;
    this.accordionMyOrdersExpanded = BooleanCons.false;
    this.accordionDoctorList = BooleanCons.false;
    this.accordionCatalog = BooleanCons.false;
    this.accordionCatalogExpanded = BooleanCons.false;
    this.accordionInvoice = BooleanCons.false;
    this.accordionUtilities = BooleanCons.false;
    this.accordionUtilitiesExpanded = BooleanCons.false;
    this.accordionSales = BooleanCons.false;
    this.accordionSalesExpanded = BooleanCons.false;
    this.accordionMissingProducts = BooleanCons.false;
    this.accountState = BooleanCons.false;
    this.promotions = BooleanCons.false;
    this.accordionSapReports = BooleanCons.false;
    this.accordionSapReportsExpandex = BooleanCons.false;
    this.codePromo = BooleanCons.false;
    this.accordionCodePromoExpandex = false;
  }
}

export class MenuItem {
  beginning: boolean;
  generateOrder: boolean;
  myProducts: boolean;
  myFavourites: boolean;
  myHistoryOrders: boolean;
  myprofile: boolean;
  myActiveOrders: boolean;
  home: boolean;
  pendingOrder: boolean;
  mydeliveredOrders: boolean;
  customers: boolean;
  bioEqual: boolean;
  bioElite: boolean;
  reve: boolean;
  dermazone: boolean;
  invoicesPending: boolean;
  invoicesPaid: boolean;
  utilities: boolean;
  averageTicket: boolean;
  goals: boolean;
  utilsCalculator: boolean;
  missingProducts: boolean;
  promotions: boolean;
  clientsWallet: boolean;
  paymentsAndBillings: boolean;
  tradeCube: boolean;
  openOrdersReport: boolean;
  quotation: boolean;
  omigenomics: boolean;
  faqs: boolean;
  incidents: boolean;
  managePromotionsCode: boolean;
  createPromotionCode: boolean;
  analysisBusiness: boolean;
  potencialBusiness: boolean;
  constructor() {
    this.beginning = BooleanCons.false;
    this.generateOrder = BooleanCons.false;
    this.myProducts = BooleanCons.false;
    this.myFavourites = BooleanCons.false;
    this.myHistoryOrders = BooleanCons.false;
    this.myprofile = BooleanCons.false;
    this.myActiveOrders = BooleanCons.false;
    this.home = BooleanCons.false;
    this.pendingOrder = BooleanCons.false;
    this.mydeliveredOrders = BooleanCons.false;
    this.customers = BooleanCons.false;
    this.bioEqual = BooleanCons.false;
    this.bioElite = BooleanCons.false;
    this.reve = BooleanCons.false;
    this.dermazone = BooleanCons.false;
    this.invoicesPending = BooleanCons.false;
    this.invoicesPaid = BooleanCons.false;
    this.utilities = BooleanCons.false;
    this.averageTicket = BooleanCons.false;
    this.goals = BooleanCons.false;
    this.utilsCalculator = BooleanCons.false;
    this.missingProducts = BooleanCons.false;
    this.promotions = BooleanCons.false;
    this.clientsWallet = BooleanCons.false;
    this.paymentsAndBillings = BooleanCons.false;
    this.tradeCube = BooleanCons.false;
    this.openOrdersReport = BooleanCons.false;
    this.quotation = BooleanCons.false;
    this.omigenomics = BooleanCons.false;
    this.faqs = BooleanCons.false;
    this.incidents = BooleanCons.false;
    this.managePromotionsCode = BooleanCons.false;
    this.createPromotionCode = BooleanCons.false;
    this.analysisBusiness = BooleanCons.false;
    this.potencialBusiness = BooleanCons.false;
  }
}
export class BreadcrumbsItems {
  back: string;
  historyOrder: boolean;
  shoppingCar: boolean;
  editarAndBuy: boolean;
  deliveryData: boolean;
  taxData: boolean;
  prescription: boolean;
  generateOrder: boolean;
  constructor() {
    this.back = RoutesCons.home;
    this.historyOrder = BooleanCons.false;
    this.shoppingCar = BooleanCons.false;
    this.editarAndBuy = BooleanCons.false;
    this.deliveryData = BooleanCons.false;
    this.taxData = BooleanCons.false;
    this.prescription = BooleanCons.false;
    this.generateOrder = BooleanCons.false;
  }
}

export interface QuantityOrdersResponse extends BaseResponseHttp {
  response: OrdersHomeCounter[];
}
export class OrdersHomeCounter {
  cardCode: string;
  ordersCounterDetail: OrdersCounterDetail;
  constructor() {
    this.cardCode = StringConst.empty;
    this.ordersCounterDetail = new OrdersCounterDetail();
  }
}
export class OrdersCounterDetail {
  Pendiente: number;
  Entregado: number;
  Activo: number;
  constructor() {
    this.Pendiente = NumberCons.zero;
    this.Entregado = NumberCons.zero;
    this.Activo = NumberCons.zero;
  }
}
